export const doorConfigurations = [
  {
    id: "single",
    name: "Single door",
    nameEt: "Ühepoolne uks",
    description: "Standard single-leaf configuration.",
    descriptionEt: "Standardne ühe ukselehega lahendus."
  },
  {
    id: "double",
    name: "Double door",
    nameEt: "Topeltuks",
    description: "Available to order. Dimensions and technical configuration are confirmed per project.",
    descriptionEt: "Saadaval tellimisel. Mõõdud ja tehniline lahendus kinnitatakse projektipõhiselt."
  },
  {
    id: "sidelight",
    name: "Door with sidelights",
    nameEt: "Küljevalgustiga uks",
    description: "Available to order with one or two sidelights. Dimensions and glazing are confirmed per project.",
    descriptionEt: "Saadaval tellimisel ühe või kahe küljevalgustiga. Mõõdud ja klaasilahendus kinnitatakse projektipõhiselt."
  }
];

export const productGroups = [
  {
    id: 1,
    name: "Smartline",
    nameEt: "Smartline",
    description: "CE-marked outwards opening exterior door for private houses",
    descriptionEt: "CE-märgistatud väljapoole avanev välisuks eramutele",
    models: [
      {
        id: "F000-GL006",
        slug: "smartline-standard",
        seoTitle: "Smartline – Outward-Opening Wooden Front Door",
        seoTitleEt: "Smartline – väljapoole avanev puidust välisuks",
        name: "Smartline",
        nameEt: "Smartline",
        configurations: doorConfigurations,
        code: "F000-GL006",
        image: "/60mm.webp",
        opening: "Outwards",
        openingEt: "Väljapoole",
        description: "SMARTLINE outwards opening exterior door for private houses.",
        descriptionEt: "SMARTLINE väljapoole avanev välisuks eramutele.",
        specs: [
          { label: "U-value", value: "0,77 (blind) / 1,0 (glass)" },
          { label: "Door thickness", value: "60 mm" },
          { label: "Frame", value: "Pine, 1-step, 44 x 105 mm" },
          { label: "Leaf construction", value: "2 aluminum sheets, 3,2 mm HDF surface" },
          { label: "Insulation", value: "EPS 50 mm" },
          { label: "Sealing", value: "In the door" },
          { label: "Threshold", value: "Oak (optional grey Accoya)" },
          { label: "Lock", value: "Lock-case 565" },
          { label: "Hinges", value: "3248-110, 2 pcs" },
          { label: "Glazing", value: "2K clear glass (glass doors only)" },
          { label: "Standard sizes", value: "9x20/21; 9,5x20,5; 10x20/21" }
        ],
        specsEt: [
          { label: "U-väärtus", value: "0,77 (pimendatud) / 1,0 (klaas)" },
          { label: "Ukse paksus", value: "60 mm" },
          { label: "Raam", value: "Mänd, 1-astmeline, 44 x 105 mm" },
          { label: "Ukse ehitus", value: "2 alumiiniumlehte, 3,2 mm HDF pind" },
          { label: "Isolatsioon", value: "EPS 50 mm" },
          { label: "Tihend", value: "Ukse sees" },
          { label: "Lävi", value: "Tamm (valikuline hall Accoya)" },
          { label: "Lukk", value: "Lukukorpus 565" },
          { label: "Hinged", value: "3248-110, 2 tk" },
          { label: "Klaas", value: "2K klaas (ainult klaasustele)" },
          { label: "Standardsuurused", value: "9x20/21; 9,5x20,5; 10x20/21" }
        ],
        keyFeatures: [
          "CE-marked, U-value 0,77 for blind doors / 1,0 for glass doors",
          "door thickness 60 mm",
          "frame depth 105 mm"
        ],
        keyFeaturesEt: [
          "CE-märgistatud, U-väärtus 0,77 pimendatud ustele / 1,0 klaasustele",
          "ukse paksus 60 mm",
          "raami sügavus 105 mm"
        ],
        technicalDetails: [
          "Door thickness 60 mm",
          "Pine 1-step frame 44 x 105 mm",
          "2 Aluminum sheet in a door",
          "3,2 mm HDF surface",
          "Insulation EPS (50 mm)",
          "Sealing in a door",
          "Threshold oak, optional grey Accoya",
          "Lock-case 565",
          "Hinges 3248-110, 2 pcs",
          "2K Clear glass (only for glass doors)",
          "Standard sizes 9x20/21; 9,5x20,5; 10x20/21"
        ],
        technicalDetailsEt: [
          "Ukse paksus 60 mm",
          "Männist 1-astmeline raam 44 x 105 mm",
          "2 alumiiniumlehte ukse sees",
          "3,2 mm HDF pind",
          "Isolatsioon EPS (50 mm)",
          "Tihend ukse sees",
          "Lävi tamm, valikuline hall Accoya",
          "Lukukorpus 565",
          "Hinged 3248-110, 2 tk",
          "2K klaas (ainult klaasustele)",
          "Standardsuurused 9x20/21; 9,5x20,5; 10x20/21"
        ]
      }
    ]
  },
  {
    id: 2,
    name: "Smartline Inward",
    nameEt: "Smartline Inward",
    description: "CE-marked inwards opening exterior door for private houses",
    descriptionEt: "CE-märgistatud sissepoole avanev välisuks eramutele",
    models: [
      {
        id: "F000-GL006-IN",
        slug: "smartline-inswing",
        seoTitle: "Smartline Inward – Inward-Opening Wooden Front Door",
        seoTitleEt: "Smartline Inward – sissepoole avanev puidust välisuks",
        name: "Smartline Inward",
        nameEt: "Smartline Inward",
        configurations: doorConfigurations,
        code: "F000-GL006",
        image: "/60mmInswing.webp",
        opening: "Inwards",
        openingEt: "Sissepoole",
        description: "SMARTLINE inwards opening exterior door for private houses.",
        descriptionEt: "SMARTLINE sissepoole avanev välisuks eramutele.",
        specs: [
          { label: "U-value", value: "0,77 (blind) / 1,0 (glass)" },
          { label: "Door thickness", value: "60 mm" },
          { label: "Frame", value: "Pine, 2-step, 56 x 115 mm" },
          { label: "Leaf construction", value: "2 aluminum sheets, 3,2 mm HDF surface" },
          { label: "Insulation", value: "EPS 50 mm" },
          { label: "Sealing", value: "In the door" },
          { label: "Threshold", value: "Aluminum" },
          { label: "Lock", value: "Lock-case 565" },
          { label: "Hinges", value: "3248-110, 2 pcs" },
          { label: "Glazing", value: "2K clear glass (glass doors only)" },
          { label: "Standard sizes", value: "9x20/21; 9,5x20,5; 10x20/21" }
        ],
        specsEt: [
          { label: "U-väärtus", value: "0,77 (pimendatud) / 1,0 (klaas)" },
          { label: "Ukse paksus", value: "60 mm" },
          { label: "Raam", value: "Mänd, 2-astmeline, 56 x 115 mm" },
          { label: "Ukse ehitus", value: "2 alumiiniumlehte, 3,2 mm HDF pind" },
          { label: "Isolatsioon", value: "EPS 50 mm" },
          { label: "Tihend", value: "Ukse sees" },
          { label: "Lävi", value: "Alumiinium" },
          { label: "Lukk", value: "Lukukorpus 565" },
          { label: "Hinged", value: "3248-110, 2 tk" },
          { label: "Klaas", value: "2K klaas (ainult klaasustele)" },
          { label: "Standardsuurused", value: "9x20/21; 9,5x20,5; 10x20/21" }
        ],
        keyFeatures: [
          "U-value 0,77 for blind doors / 1,0 for glass doors",
          "door thickness 60 mm",
          "frame depth 115 mm"
        ],
        keyFeaturesEt: [
          "U-väärtus 0,77 pimendatud ustele / 1,0 klaasustele",
          "ukse paksus 60 mm",
          "raami sügavus 115 mm"
        ],
        technicalDetails: [
          "Door thickness 60 mm",
          "Pine 2-step frame 56 x 115 mm",
          "2 Aluminum sheet in a door",
          "3,2 mm HDF surface",
          "Insulation EPS (50 mm)",
          "Sealing in a door",
          "Threshold Aluminum",
          "Lock-case 565",
          "Hinges 3248-110, 2 pcs",
          "2K Clear glass (only for glass doors)",
          "Standard sizes 9x20/21; 9,5x20,5; 10x20/21"
        ],
        technicalDetailsEt: [
          "Ukse paksus 60 mm",
          "Männist 2-astmeline raam 56 x 115 mm",
          "2 alumiiniumlehte ukse sees",
          "3,2 mm HDF pind",
          "Isolatsioon EPS (50 mm)",
          "Tihend ukse sees",
          "Alumiiniumlävi",
          "Lukukorpus 565",
          "Hinged 3248-110, 2 tk",
          "2K klaas (ainult klaasustele)",
          "Standardsuurused 9x20/21; 9,5x20,5; 10x20/21"
        ]
      }
    ]
  },
  {
    id: 3,
    catalogVisible: false,
    name: "SMARTLINE PLUS outwards opening door",
    nameEt: "SMARTLINE PLUS väljapoole avanev uks",
    description: "CE-marked outwards opening exterior door for private houses",
    descriptionEt: "CE-märgistatud väljapoole avanev välisuks eramutele",
    models: [
      {
        id: "F000-GL006-PLUS",
        slug: "smartline-plus",
        seoTitle: "Smartline Plus – Outward-Opening Wooden Front Door",
        seoTitleEt: "Smartline Plus – väljapoole avanev puidust välisuks",
        catalogVisible: false,
        name: "SMARTLINE PLUS",
        nameEt: "SMARTLINE PLUS",
        code: "F000-GL006",
        image: "/60mm.webp",
        opening: "Outwards",
        openingEt: "Väljapoole",
        description: "SMARTLINE PLUS outwards opening exterior door for private houses.",
        descriptionEt: "SMARTLINE PLUS väljapoole avanev välisuks eramutele.",
        specs: [
          { label: "U-value", value: "0,77 (blind) / 1,0 (glass)" },
          { label: "Door thickness", value: "60 mm" },
          { label: "Frame", value: "Pine, 1-step, 56 x 115 mm" },
          { label: "Leaf construction", value: "2 aluminum sheets, 3,2 mm HDF surface" },
          { label: "Insulation", value: "EPS 50 mm" },
          { label: "Sealing", value: "In the door" },
          { label: "Threshold", value: "Aluminum" },
          { label: "Lock", value: "3-point lock FIX2150 (optional 565, ASSA 2002, ASSA 410-50)" },
          { label: "Hinges", value: "3248-110, 3 pcs" },
          { label: "Glazing", value: "2K clear glass (glass doors only)" },
          { label: "Standard sizes", value: "9x20/21; 9,5x20,5; 10x20/21" }
        ],
        specsEt: [
          { label: "U-väärtus", value: "0,77 (pimendatud) / 1,0 (klaas)" },
          { label: "Ukse paksus", value: "60 mm" },
          { label: "Raam", value: "Mänd, 1-astmeline, 56 x 115 mm" },
          { label: "Ukse ehitus", value: "2 alumiiniumlehte, 3,2 mm HDF pind" },
          { label: "Isolatsioon", value: "EPS 50 mm" },
          { label: "Tihend", value: "Ukse sees" },
          { label: "Lävi", value: "Alumiinium" },
          { label: "Lukk", value: "3-punkti lukk FIX2150 (valikuline 565, ASSA 2002, ASSA 410-50)" },
          { label: "Hinged", value: "3248-110, 3 tk" },
          { label: "Klaas", value: "2K klaas (ainult klaasustele)" },
          { label: "Standardsuurused", value: "9x20/21; 9,5x20,5; 10x20/21" }
        ],
        keyFeatures: [
          "U-value 0,77 for blind doors / 1,0 for glass doors",
          "door thickness 60 mm",
          "frame depth 115 mm"
        ],
        keyFeaturesEt: [
          "U-väärtus 0,77 pimendatud ustele / 1,0 klaasustele",
          "ukse paksus 60 mm",
          "raami sügavus 115 mm"
        ],
        technicalDetails: [
          "Door thickness 60 mm",
          "Pine 1-step frame 56 x 115 mm",
          "2 Aluminum sheet in a door",
          "3,2 mm HDF surface",
          "Insulation EPS (50 mm)",
          "Sealing in a door",
          "Threshold Aluminum",
          "3-point lock FIX2150, optional 565, ASSA 2002, ASSA 410-50",
          "Hinges 3248-110, 3 pcs",
          "2K Clear glass (only for glass doors)",
          "Standard sizes 9x20/21; 9,5x20,5; 10x20/21"
        ],
        technicalDetailsEt: [
          "Ukse paksus 60 mm",
          "Männist 1-astmeline raam 56 x 115 mm",
          "2 alumiiniumlehte ukse sees",
          "3,2 mm HDF pind",
          "Isolatsioon EPS (50 mm)",
          "Tihend ukse sees",
          "Alumiiniumlävi",
          "3-punkti lukk FIX2150, valikuline 565, ASSA 2002, ASSA 410-50",
          "Hinged 3248-110, 3 tk",
          "2K klaas (ainult klaasustele)",
          "Standardsuurused 9x20/21; 9,5x20,5; 10x20/21"
        ]
      }
    ]
  },
  {
    id: 4,
    name: "Cottage",
    nameEt: "Cottage",
    description: "Door for cold storages where temperature difference between the inside and outside do not exceed 10°C",
    descriptionEt: "Uks külmlaadadele ja kuuridele, kus temperatuuride erinevus ei ületa 10°C",
    models: [
      {
        id: "C10",
        slug: "cottage-door",
        seoTitle: "Cottage Door – for Sheds & Cold Stores (10 °C)",
        seoTitleEt: "Cottage – uks kuuridele ja külmladudele (10 °C)",
        name: "Cottage",
        nameEt: "Cottage",
        configurations: doorConfigurations,
        code: "C10",
        image: "/Cottage.webp",
        opening: "Outwards",
        openingEt: "Väljapoole",
        description: "COTTAGE DOOR 10°C for cold stores and sheds",
        descriptionEt: "SUVEMAJA UKS 10°C külmlaadadele ja kuuridele",
        specs: [
          { label: "Temperature range", value: "Up to 10°C difference" },
          { label: "Door thickness", value: "47 mm" },
          { label: "Frame", value: "Pine, 1-step, 42 x 92 mm" },
          { label: "Leaf construction", value: "3-layer Meranti plywood 2,7 mm, pine paneling on outer side" },
          { label: "Insulation", value: "EPS 33 mm" },
          { label: "Sealing", value: "In the frame" },
          { label: "Threshold", value: "Pine, same profile as frame" },
          { label: "Lock", value: "Lock-case 565" },
          { label: "Hinges", value: "3248-110, 2 pcs" },
          { label: "Glazing", value: "4 mm clear glass (glass doors only)" },
          { label: "Standard sizes", value: "9x19/20; 9,5x20,5; 9/10 x 20/21M" }
        ],
        specsEt: [
          { label: "Temperatuurivahemik", value: "Kuni 10°C erinevus" },
          { label: "Ukse paksus", value: "47 mm" },
          { label: "Raam", value: "Mänd, 1-astmeline, 42 x 92 mm" },
          { label: "Ukse ehitus", value: "3-kihiline Meranti vineer 2,7 mm, männivooderdis välisküljel" },
          { label: "Isolatsioon", value: "EPS 33 mm" },
          { label: "Tihend", value: "Raamis" },
          { label: "Lävi", value: "Mänd, sama profiil kui raamil" },
          { label: "Lukk", value: "Lukukorpus 565" },
          { label: "Hinged", value: "3248-110, 2 tk" },
          { label: "Klaas", value: "4 mm klaas (ainult klaasustele)" },
          { label: "Standardsuurused", value: "9x19/20; 9,5x20,5; 9/10 x 20/21M" }
        ],
        keyFeatures: [
          "pine paneling on outer side",
          "door thickness 47 mm",
          "frame depth 92 mm"
        ],
        keyFeaturesEt: [
          "männivooderdis välisküljel",
          "ukse paksus 47 mm",
          "raami sügavus 92 mm"
        ],
        technicalDetails: [
          "Door thickness 47 mm",
          "Pine 1-step frame 42 x 92 mm",
          "3-layer Meranti plywood 2,7 mm",
          "Insulation EPS (33 mm)",
          "Sealing in a frame",
          "Threshold pine, same profile as a frame",
          "lock-case 565",
          "Hinges 3248-110, 2 pcs",
          "4 mm Clear glass (only for glass doors)",
          "Standard sizes 9x19/20; 9,5x20,5; 9/10 x 20/21M"
        ],
        technicalDetailsEt: [
          "Ukse paksus 47 mm",
          "Männist 1-astmeline raam 42 x 92 mm",
          "3-kihiline Meranti vineer 2,7 mm",
          "Isolatsioon EPS (33 mm)",
          "Tihend raamis",
          "Lävi mänd, sama profiil kui raamil",
          "Lukukorpus 565",
          "Hinged 3248-110, 2 tk",
          "4 mm klaas (ainult klaasustele)",
          "Standardsuurused 9x19/20; 9,5x20,5; 9/10 x 20/21M"
        ]
      }
    ]
  },
  {
    id: 5,
    name: "Meranti",
    nameEt: "Meranti",
    description: "Doors for cold storage rooms and sheds where temperature difference between the inside and outside do not exceed 10°C",
    descriptionEt: "Uksed külmlaadadele ja kuuridele, kus temperatuuride erinevus ei ületa 10°C",
    models: [
      {
        id: "M10",
        slug: "meranti-door",
        seoTitle: "Meranti Door – for Sheds & Cold Stores",
        seoTitleEt: "Meranti uks – kuuridele ja külmladudele",
        name: "Meranti",
        nameEt: "Meranti",
        configurations: doorConfigurations,
        code: "M10",
        image: "/Meranti.webp",
        opening: "Outwards",
        openingEt: "Väljapoole",
        description: "Meranti doors for cold stores and sheds",
        descriptionEt: "Meranti uksed külmlaadadele ja kuuridele",
        specs: [
          { label: "Temperature range", value: "Up to 10°C difference" },
          { label: "Door thickness", value: "47 mm" },
          { label: "Frame", value: "Pine, 1-step, 42 x 92 mm" },
          { label: "Leaf construction", value: "3-layer Meranti plywood 2,7 mm on both sides" },
          { label: "Insulation", value: "EPS 40 mm" },
          { label: "Sealing", value: "In the frame" },
          { label: "Threshold", value: "Pine, same profile as frame" },
          { label: "Lock", value: "Lock-case 565" },
          { label: "Hinges", value: "3248-110, 2 pcs" },
          { label: "Glazing", value: "4 mm clear glass (glass doors only)" },
          { label: "Standard sizes", value: "9x19/20; 9,5x20,5; 9/10 x 20/21M" }
        ],
        specsEt: [
          { label: "Temperatuurivahemik", value: "Kuni 10°C erinevus" },
          { label: "Ukse paksus", value: "47 mm" },
          { label: "Raam", value: "Mänd, 1-astmeline, 42 x 92 mm" },
          { label: "Ukse ehitus", value: "3-kihiline Meranti vineer 2,7 mm mõlemal küljel" },
          { label: "Isolatsioon", value: "EPS 40 mm" },
          { label: "Tihend", value: "Raamis" },
          { label: "Lävi", value: "Mänd, sama profiil kui raamil" },
          { label: "Lukk", value: "Lukukorpus 565" },
          { label: "Hinged", value: "3248-110, 2 tk" },
          { label: "Klaas", value: "4 mm klaas (ainult klaasustele)" },
          { label: "Standardsuurused", value: "9x19/20; 9,5x20,5; 9/10 x 20/21M" }
        ],
        keyFeatures: [
          "Meranti plywood surface on both sides",
          "door thickness 47 mm",
          "frame depth 92 mm"
        ],
        keyFeaturesEt: [
          "Meranti vineer pind mõlemal küljel",
          "ukse paksus 47 mm",
          "raami sügavus 92 mm"
        ],
        technicalDetails: [
          "Door thickness 47 mm",
          "Pine 1-step frame 42 x 92 mm",
          "3-layer Meranti plywood 2,7 mm",
          "Insulation EPS (40 mm)",
          "Sealing in a frame",
          "Threshold pine, same profile as a frame",
          "lock-case 565",
          "Hinges 3248-110, 2 pcs",
          "4 mm Clear glass (only for glass doors)",
          "Standard sizes 9x19/20; 9,5x20,5; 9/10 x 20/21M"
        ],
        technicalDetailsEt: [
          "Ukse paksus 47 mm",
          "Männist 1-astmeline raam 42 x 92 mm",
          "3-kihiline Meranti vineer 2,7 mm",
          "Isolatsioon EPS (40 mm)",
          "Tihend raamis",
          "Lävi mänd, sama profiil kui raamil",
          "Lukukorpus 565",
          "Hinged 3248-110, 2 tk",
          "4 mm klaas (ainult klaasustele)",
          "Standardsuurused 9x19/20; 9,5x20,5; 9/10 x 20/21M"
        ]
      }
    ]
  },
  {
    id: 6,
    name: "18Deg",
    nameEt: "18Deg",
    description: "Doors for warm storage rooms and sheds where temperature difference between the inside and outside do not exceed 18°C",
    descriptionEt: "Uksed soojadele laoruumidele ja kuuridele, kus temperatuuride erinevus ei ületa 18°C",
    models: [
      {
        id: "W20",
        slug: "warm-storage-door-18",
        seoTitle: "18Deg – Door for Warm Stores & Sheds (18 °C)",
        seoTitleEt: "18Deg – uks soojadele ladudele ja kuuridele (18 °C)",
        name: "18Deg",
        nameEt: "18Deg",
        configurations: doorConfigurations,
        code: "W20",
        image: "/18Deg-RAL9016.webp",
        opening: "Outwards",
        openingEt: "Väljapoole",
        description: "18° doors for warm stores and sheds",
        descriptionEt: "18° uksed soaladele ja kuuridele",
        specs: [
          { label: "Temperature range", value: "Up to 18°C difference" },
          { label: "Door thickness", value: "47 mm" },
          { label: "Frame", value: "Pine, 1-step, 42 x 92 mm" },
          { label: "Leaf construction", value: "3-layer Meranti plywood 2,7 mm on both sides" },
          { label: "Insulation", value: "EPS 40 mm" },
          { label: "Sealing", value: "In the frame" },
          { label: "Threshold", value: "Pine, same profile as frame (optional oak)" },
          { label: "Lock", value: "Lock-case 565" },
          { label: "Hinges", value: "3248-110, 2 pcs" },
          { label: "Glazing", value: "2K clear glass (glass doors only)" },
          { label: "Standard sizes", value: "9x19/20; 9,5x20,5; 9/10 x 20/21M" }
        ],
        specsEt: [
          { label: "Temperatuurivahemik", value: "Kuni 18°C erinevus" },
          { label: "Ukse paksus", value: "47 mm" },
          { label: "Raam", value: "Mänd, 1-astmeline, 42 x 92 mm" },
          { label: "Ukse ehitus", value: "3-kihiline Meranti vineer 2,7 mm mõlemal küljel" },
          { label: "Isolatsioon", value: "EPS 40 mm" },
          { label: "Tihend", value: "Raamis" },
          { label: "Lävi", value: "Mänd, sama profiil kui raamil (valikuline tamm)" },
          { label: "Lukk", value: "Lukukorpus 565" },
          { label: "Hinged", value: "3248-110, 2 tk" },
          { label: "Klaas", value: "2K klaas (ainult klaasustele)" },
          { label: "Standardsuurused", value: "9x19/20; 9,5x20,5; 9/10 x 20/21M" }
        ],
        keyFeatures: [
          "Meranti plywood surface on both sides",
          "door thickness 47 mm",
          "frame depth 92 mm"
        ],
        keyFeaturesEt: [
          "Meranti vineer pind mõlemal küljel",
          "ukse paksus 47 mm",
          "raami sügavus 92 mm"
        ],
        technicalDetails: [
          "Door thickness 47 mm",
          "Pine 1-step frame 42 x 92 mm",
          "3-layer Meranti plywood 2,7 mm",
          "Insulation EPS (40 mm)",
          "Sealing in a frame",
          "Threshold pine, same profile as a frame; optional oak",
          "Lock-case 565",
          "Hinges 3248-110, 2 pcs",
          "2K Clear glass (only for glass doors)",
          "Standard sizes 9x19/20; 9,5x20,5; 9/10 x 20/21M"
        ],
        technicalDetailsEt: [
          "Ukse paksus 47 mm",
          "Männist 1-astmeline raam 42 x 92 mm",
          "3-kihiline Meranti vineer 2,7 mm",
          "Isolatsioon EPS (40 mm)",
          "Tihend raamis",
          "Lävi mänd, sama profiil kui raamil; valikuline tamm",
          "Lukukorpus 565",
          "Hinged 3248-110, 2 tk",
          "2K klaas (ainult klaasustele)",
          "Standardsuurused 9x19/20; 9,5x20,5; 9/10 x 20/21M"
        ]
      }
    ]
  }
];
